import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import CourseProp from '../propTypes/courseProp';
import MoreInfo from '../../shared/MoreInfo';

function AcademyCourseMoreInfo({ t, course }) {
  return (
    <>
      <MoreInfo
        contentId={course._id}
        startCollapsed
        title={t('academyDetails_about')}
        description={course.description}
        motivationTitle={t('academyDetails_why')}
        motivation={course.motivation}
      />
      <div />
    </>
  );
}

AcademyCourseMoreInfo.propTypes = {
  t: PropTypes.func.isRequired,
  course: PropTypes.shape(CourseProp.propType).isRequired,
};

export default translate(AcademyCourseMoreInfo);
